// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".columns.is-2 > .column[data-v-28a76d6a] {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}", ""]);
// Exports
module.exports = exports;
